<template>
  <div v-if="hasFormAccess">
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <!-- Card header -->
            <div class="pb-0 card-header">
              <div class="d-lg-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center gap-2">
                  <router-link class="back-link" to="/account-management/manage-role">
                    <i class="fa fa-arrow-left"></i>
                  </router-link>
                  <div>
                    <h5 class="mb-0 header-title">
                      {{ $route.params.action === 'create' ? 'Create Role' : 'Edit Role' }}
                    </h5>
                  </div>
                </div>
                <div class="d-flex gap-2 mt-2 mt-lg-0">
                  <button class="btn-header btn-header--reset" @click="reset">
                    <i class="fa fa-undo me-1"></i>Reset
                  </button>
                  <button type="button" class="btn-header btn-header--save" :disabled="btnSave.onLoading" @click="save">
                    <i v-if="btnSave.onLoading" class="fa fa-spinner fa-spin me-1"></i>
                    <i v-else class="fa fa-save me-1"></i>
                    {{ $route.params.action === 'create' ? 'Create' : 'Update' }}
                  </button>
                </div>
              </div>
            </div>
            <!-- Card Body -->
            <div class="pb-0 card-body mt-3 mb-5" style="height: 100%;">
              <div v-if='!(pageLoading || btnSave.onLoading)'>
                <div class="row mb-4">
                  <div class="col-12">
                    <label class="form-label">Name<span class="text-danger">*</span></label>
                    <InputText
v-model="roles.role_name" class="w-100"
                      :class="`${(errorMessage['role_name'] && roles.role_name == '') ? 'border-danger' : ''}`"
                      placeholder="Enter Role Name" @focus="updateField('role_name')" />
                    <small v-if="errorMessage['role_name'] && roles.role_name == ''" class="text-danger">{{
                      errorMessage['role_name'] }}</small>
                  </div>
                </div>
                <hr>
                <div class="row mb-4">
                  <div class="col-12">
                    <div class="permissions-header">
                      <div class="d-flex align-items-center gap-2">
                        <!-- <i class="fa fa-key text-primary"></i> -->
                        <h6 class="text-uppercase text-body text-md mb-0 fw-bold">Role Permissions</h6>
                      </div>
                      <div class="d-flex align-items-center gap-3">
                        <span v-if="errorMessage['permissions']" class="text-danger text-xs">
                          <i class="fa fa-exclamation-circle me-1"></i>{{ errorMessage['permissions'] }}
                        </span>
                        <label
class="check-all-label"
                          :class="{ 'check-all-label--error': errorMessage['permissions'] }">
                          <input
type="checkbox" :disabled="permissionsLoading" class="check-all-input"
                            @click="checkAll" @focus="updateField('permissions')">
                          <span>Check All</span>
                        </label>
                      </div>
                    </div>

                    <!-- Menu sections dengan collapsible -->
                    <div
v-for="(menu, idx) in menus" :key="menu.menu_id" class="menu-section"
                      :class="{ 'menu-section--last': idx === menus.length - 1 }">

                      <!-- Header section yang bisa diklik -->
                      <div
class="section-toggle-header"
                        :class="{ 'section-toggle-header--open': openSections[menu.menu_id] }"
                        @click="toggleSection(menu.menu_id)">
                        <div class="d-flex align-items-center gap-2">
                          <span class="section-dot"></span>
                          <h6 class="text-uppercase text-md text-sm mb-0 section-title">
                            {{ menu.menu_name }}
                          </h6>
                        </div>
                        <i
class="fa chevron-icon"
                          :class="openSections[menu.menu_id] ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                      </div>

                      <!-- Konten section (bisa buka/tutup) -->
                      <div v-show="openSections[menu.menu_id]" class="section-body">
                        <div
v-for="(sub, sIdx) in menu.sub_menus" :key="sub.sub_menu_id" class="sub-menu-block"
                          :class="{ 'sub-menu-block--last': sIdx === menu.sub_menus.length - 1 }">
                          <!-- Sub-menu title + Select All di pojok kanan -->
                          <div class="sub-menu-header-row">
                            <h5 class="sub-menu-title">{{ sub.sub_menu_name }}</h5>
                            <span class="sub-menu-divider"></span>
                            <label class="section-check-all-label flex-shrink-0" @click.stop>
                              <input
type="checkbox" class="section-check-all-input" :checked="isSubAllChecked(sub)"
                                :indeterminate.prop="isSubIndeterminate(sub)" @change="checkAllSub(sub, $event)"
                                @focus="updateField('permissions')" />
                              <span>Select All</span>
                            </label>
                          </div>
                          <div class="row ms-2">
                            <div v-for="p in sub.permissions" :key="p.id" class="col-3 text-body text-sm my-1">
                              <label class="perm-label">
                                <input
:id="p.id" v-model="roles.permissions" type="checkbox" :value="p.name"
                                  class="perm-checkbox" @focus="updateField('permissions')">
                                <span class="perm-text">{{ p.type }}</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="px-4 pt-5">
                <Skeleton width="100%" height="2rem" class="mb-3" />
                <Skeleton width="80%" height="2rem" class="mb-3" />
                <Skeleton width="60%" height="2rem" class="mb-3" />
                <Skeleton width="100%" height="2.5rem" class="mb-3 mt-5" />
                <Skeleton width="100%" height="15rem" class="mb-3" />
                <Skeleton width="100%" height="2.5rem" class="mb-3" />
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
  <NoAccess v-else />
</template>

<script>
import { mapState } from "vuex";
import api from '@/helpers/api';
import manageRoleService from '@/services/manageAccount/manageRoleService';
import managePermissionService from '@/services/manageAccount/managePermissionService';
import NoAccess from "@/components/NoAccess.vue";

export default {
  components: { NoAccess },
  data() {
    return {
      btnSave: {
        onLoading: false,
      },
      pageLoading: false,
      userSSO: {
        onLoad: false,
        data: [],
      },
      roles: {
        role_name: '',
        guard_name: 'api',
        permissions: []
      },
      errorMessage: [],
      oriCompletePermissions: [],
      loadTimeout: null,
      menus: [],
      guardOptions: [
        { label: 'API', value: 'api' },
        { label: 'Web', value: 'web' }
      ],
      permissionsLoading: false,
      openSections: {}, // { [menu_id]: true/false }
    }
  },
  computed: {
    ...mapState({
      authUserPermissions: (state) => state.auth.userHasPermissions || [],
    }),
    hasFormAccess() {
      return this.$route.params.action === 'create'
        ? this.hasAnyPermission('role-create')
        : this.hasAnyPermission('role-update');
    },
  },
  watch: {
  },
  async mounted() {
    this.pageLoading = true;
    try {
      if (this.hasFormAccess) {
        await this.getMenus();
        await this.getRoles();
      }
    } finally {
      this.pageLoading = false;
    }
  },
  methods: {
    hasAnyPermission(...perms) {
      return perms.some((p) => this.authUserPermissions.includes(p));
    },
    async getMenus() {
      this.permissionsLoading = true;
      try {
        const response = await api(this, managePermissionService.listAll(), false);

        this.menus = response.data || [];

        this.oriCompletePermissions = [];
        response.data.forEach(menu => {
          menu.sub_menus.forEach(sub => {
            sub.permissions.forEach(permission => {
              this.oriCompletePermissions.push(permission);
            });
          });
        });

        // Semua section terbuka secara default
        const sections = {};
        this.menus.forEach(menu => {
          sections[menu.menu_id] = true;
        });
        this.openSections = sections;

        return response;
      } catch (error) {
        if (error.response?.data?.code == 400) {
          error.response.data.data.forEach((v) => {
            this.menus = []
            this.errorMessage[v.path] = v.msg
          })
        }
        throw error;
      } finally {
        this.permissionsLoading = false;
      }
    },
    async getRoles() {
      if (this.$route.params.action === 'edit' && this.$route.params.dataRoleCode) {
        try {
          const response = await api(this, manageRoleService.detail(this.$route.params.dataRoleCode), false)
          this.roles.role_name = response.data.name
          this.roles.guard_name = response.data.guard_name || ''
          this.roles.permissions = (response.data.permissions || []).map(permis => permis.name)
        } catch (error) {
          this.roles = {
            role_name: '',
            guard_name: '',
            permissions: []
          }
        }
      }
    },
    toggleSection(menuId) {
      this.openSections = {
        ...this.openSections,
        [menuId]: !this.openSections[menuId]
      };
    },
    checkAll(event) {
      if (event.target.checked) {
        this.oriCompletePermissions.forEach(permission => {
          if (!this.roles.permissions.includes(permission.name)) {
            this.roles.permissions.push(permission.name);
          }
        });
      } else {
        this.roles.permissions = []
      }
    },
    // Ambil semua nama permission dalam satu sub-menu
    getSubPerms(sub) {
      return sub.permissions.map(p => p.name);
    },
    // Cek apakah semua permission di sub-menu sudah dicentang
    isSubAllChecked(sub) {
      const names = this.getSubPerms(sub);
      return names.length > 0 && names.every(n => this.roles.permissions.includes(n));
    },
    // Cek apakah hanya sebagian (indeterminate)
    isSubIndeterminate(sub) {
      const names = this.getSubPerms(sub);
      const checkedCount = names.filter(n => this.roles.permissions.includes(n)).length;
      return checkedCount > 0 && checkedCount < names.length;
    },
    // Check / uncheck semua permission dalam satu sub-menu
    checkAllSub(sub, event) {
      const names = this.getSubPerms(sub);
      if (event.target.checked) {
        names.forEach(name => {
          if (!this.roles.permissions.includes(name)) {
            this.roles.permissions.push(name);
          }
        });
      } else {
        this.roles.permissions = this.roles.permissions.filter(n => !names.includes(n));
      }
      this.updateField('permissions');
    },
    reset() {
      this.roles.role_name = ''
      this.roles.guard_name = 'api'
      this.roles.permissions = []
    },
    save() {
      this.errorMessage = {};
      let isValid = true

      if (this.roles.role_name == '' || this.roles.role_name == undefined || this.roles.role_name == null) {
        this.errorMessage['role_name'] = 'Name required';
        isValid = false
      }
      if (this.roles.permissions.length === 0) {
        this.errorMessage['permissions'] = 'At least one permission must be assigned'
        isValid = false
      }

      if (!isValid) {
        const textError = 'There fields have not been filled'
        this.errorPopUpMsg(textError)
        return isValid
      }

      const payload = {
        name: this.roles.role_name,
        guard_name: this.roles.guard_name,
        permissions: this.roles.permissions
      };

      this.btnSave.onLoading = true;
      setTimeout(async () => {
        try {
          let response;
          if (this.$route.params.action === 'create') {
            response = await api(this, manageRoleService.create(payload));
          } else if (this.$route.params.action === 'edit' && this.$route.params.dataRoleCode) {
            response = await api(this, manageRoleService.update(this.$route.params.dataRoleCode, payload));
          }

          if (response) {
            this.roles.role_name = response.data.name;
            this.roles.guard_name = response.data.guard_name;
            this.roles.permissions = (response.data.permissions || []).map(p => p.name);
            if (this.$route.params.action === 'create') {
              this.$router.push({ name: 'Manage Role', params: { moduleSlug: 'material-management' } });
            } else if (this.$route.params.action === 'edit' && this.$route.params.dataRoleCode) {
              this.$router.push({ name: 'Manage Role', params: { moduleSlug: 'material-management' } });
            }
          }

        } catch (error) {
          if (error.response?.data?.code === 400) {
            error.response.data.data.forEach((v) => {
              this.errorMessage[v.path] = v.msg;
            });
          }
        } finally {
          this.btnSave.onLoading = false;
        }
      }, 500);
    },
    updateField(field) {
      delete this.errorMessage[field]
    },
    errorPopUpMsg(msg) {
      this.$swal({
        icon: 'error',
        title: 'Error',
        text: msg,
      });
    },
    formatRoleCode(roleCode) {
      const words = roleCode.replace(/[^a-zA-Z0-9 ]/g, ' ').split(' ');
      const formatted = words.map((word, index) =>
        index === 0
          ? word.toLowerCase()
          : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      );
      return formatted.join('');
    }
  }
};
</script>

<style scoped>
/* ── Section Check All ────────────────────────── */
.section-check-all-label {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #566083;
  cursor: pointer;
  padding: 1px 8px;
  border-radius: 6px;
  border: 1.5px solid #d5daea;
  background: #fff;
  transition: all 0.2s;
  user-select: none;
  white-space: nowrap;
  line-height: 1.6;
}

.section-check-all-label:hover {
  border-color: #344767;
  background: #f0f2fa;
  color: #344767;
}

.section-check-all-input {
  width: 13px;
  height: 13px;
  accent-color: #344767;
  cursor: pointer;
  flex-shrink: 0;
}

/* ── Sub-menu Divider (garis ─ ─ ─ antara title dan Select All) */
.sub-menu-header-row {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 6px;
  margin-top: 4px;
}

.sub-menu-title {
  font-size: 0.8rem;
  font-weight: 600;
  color: #566083;
  margin: 0;
  padding: 0;
  line-height: 1.4;
  flex-shrink: 0;
  white-space: nowrap;
  position: relative;
  top: -4px;
}

.sub-menu-divider {
  flex: 1;
  height: 0;
  border-top: 2px dashed #dde1ed;
  min-width: 16px;
  position: relative;
  top: -5px;
}

/* ── Header Buttons ───────────────────────────── */
.btn-header {
  display: inline-flex;
  align-items: center;
  padding: 6px 16px;
  border-radius: 7px;
  border: none;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-header--reset {
  background: #fff;
  color: #e74c3c;
  border: 1.5px solid #f5c6cb;
}

.btn-header--reset:hover {
  background: #fff5f5;
  border-color: #e74c3c;
}

.btn-header--save {
  background: linear-gradient(135deg, #344767, #566083);
  color: #fff;
  box-shadow: 0 3px 10px rgba(52, 71, 103, 0.3);
}

.btn-header--save:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 5px 14px rgba(52, 71, 103, 0.4);
}

.btn-header--save:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

/* ── Permissions Header ───────────────────────── */
.permissions-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 2px solid #f0f2f5;
}

.check-all-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.82rem;
  font-weight: 600;
  color: #344767;
  cursor: pointer;
  padding: 4px 10px;
  border-radius: 6px;
  border: 1.5px solid #dee2e6;
  background: #fff;
  transition: all 0.2s;
  user-select: none;
}

.check-all-label:hover {
  border-color: #344767;
  background: #f8f9ff;
}

.check-all-label--error {
  border-color: #f5c6cb;
  color: #e74c3c;
}

.check-all-input {
  width: 14px;
  height: 14px;
  accent-color: #344767;
  cursor: pointer;
}

/* ── Menu Section ─────────────────────────────── */
.menu-section {
  border: 1px solid #e9ecef;
  border-radius: 10px;
  margin-bottom: 8px;
  overflow: hidden;
  transition: box-shadow 0.2s;
}

.menu-section:hover {
  box-shadow: 0 2px 10px rgba(52, 71, 103, 0.08);
}

.menu-section--last {
  margin-bottom: 0;
}

/* ── Section Toggle Header ────────────────────── */
.section-toggle-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: #f8f9fb;
  cursor: pointer;
  user-select: none;
  transition: background 0.2s;
  border-bottom: 1px solid transparent;
}

.section-toggle-header:hover {
  background: #eef0f7;
}

.section-toggle-header--open {
  background: #eef0f7;
  border-bottom-color: #e2e6ef;
}

.section-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: linear-gradient(135deg, #344767, #566083);
  flex-shrink: 0;
}

.section-title {
  color: #344767;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.chevron-icon {
  font-size: 0.72rem;
  color: #8898aa;
  transition: transform 0.25s;
}

/* ── Section Body ─────────────────────────────── */
.section-body {
  padding: 10px 14px 14px;
  background: #fff;
}

.sub-menu-block {
  padding-bottom: 10px;
  margin-bottom: 8px;
  border-bottom: 1px dashed #edf0f7;
}

.sub-menu-block--last {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.sub-menu-title {
  font-size: 0.8rem;
  font-weight: 600;
  color: #566083;
}

/* ── Permission Checkbox ──────────────────────── */
.perm-label {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  font-size: 0.82rem;
  color: #4a5568;
}

.perm-checkbox {
  accent-color: #344767;
  width: 14px;
  height: 14px;
  cursor: pointer;
  flex-shrink: 0;
}

.perm-text {
  text-transform: capitalize;
}

.perm-label:hover .perm-text {
  color: #344767;
  font-weight: 500;
}
</style>